import { createFileRoute } from "@tanstack/react-router"
import { usePageTracking } from "~/hooks/usePageTracking"
import ForecastCalendar from "~/pages/forecasting/forecast-calendar"

export const Route = createFileRoute("/_auth/insights/forecast-calendar")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Forecast Calendar")
  return <ForecastCalendar />
}
